/**
 * Every comment thread of the project (vfs-service `/collab/comments`, the same threads the editor's comments panel
 * shows), with Reply and Resolve; a thread's file link opens the file at its line in Code (`onOpenFile`), or nothing
 * where the plan hides Code. New comments are written in the editor, on a line or a file.
 *
 * - ProjectCommentsBody: the list, Team ▾ › Notes › Comments (collab/NotesModal.jsx).
 * - ProjectComments (default): the same list in a dialog of its own.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import CommentsPanel from './CommentsPanel';

const noop = () => {};

/** `onClose` closes what holds the list, before a file link opens the file. */
export function ProjectCommentsBody({ projectId, onClose, onOpenFile = null }) {
  return (
    <div data-testid="project-comments">
      <CommentsPanel
        floating={false}
        onChanged={noop}
        onClose={onClose}
        onGoToLine={(thread) => {
          if (!onOpenFile || !thread?.path) { return; }
          onClose();
          onOpenFile({ path: thread.path, line: Number.isInteger(thread.line) ? thread.line : null });
        }}
        projectId={projectId}
        projectOnly
        sheet
        threads={[]}
      />
      <p className="collab-muted collab-small">To start a thread, open a file in Code and comment on a line.</p>
    </div>
  );
}

ProjectCommentsBody.propTypes = {
  onClose: PropTypes.func.isRequired,
  // ({ path, line }) => void: the file at that line in Code; none where the plan hides Code.
  onOpenFile: PropTypes.func,
  projectId: PropTypes.string.isRequired,
};

export default function ProjectComments({ projectId, open, onClose, onOpenFile = null }) {
  return (
    <Modal destroyOnClose footer={null} onCancel={onClose} open={open} title="Comments" width={560}>
      <ProjectCommentsBody onClose={onClose} onOpenFile={onOpenFile} projectId={projectId} />
    </Modal>
  );
}

ProjectComments.propTypes = {
  onClose: PropTypes.func.isRequired,
  onOpenFile: PropTypes.func,
  open: PropTypes.bool,
  projectId: PropTypes.string.isRequired,
};
